import { useState, useRef, useEffect } from 'react'
import { MessageSquareText, Search, Send, Plus, ArrowLeft, ChevronDown } from 'lucide-react';
import { RxCrossCircled } from 'react-icons/rx';
import { MdImage, MdVideoLibrary } from 'react-icons/md';
import placeholder from "../../assets/images/user.png"
import { Video } from 'lucide-react';
import { MessagesSkeleton } from '../../components/Skeleton';
import 'react-medium-image-zoom/dist/styles.css'
import { Socket } from '../../Socket/Socket';
import { getChatsAPI, getChatMessagesAPI, sendMessageAPI } from '../../service/ApiServices';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDebounce } from 'use-debounce';
import toast from 'react-hot-toast';
import Zoom from 'react-medium-image-zoom'
import moment from 'moment/moment';
import { useRoomManager } from '../../components/RoomManager';
import { validateUrl } from '../../base_component/Common/data';
import profileImage from "../../assets/images/user.png";
import { useNavigate, useLocation } from 'react-router-dom';

export default function Messages() {
    const [message, setMessage] = useState("");
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [showScrollButton, setShowScrollButton] = useState(false);
    const [joined, setJoined] = useState(false);
    const [previews, setPreviews] = useState([])
    const [chatRooms, setChatRooms] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [debouncedSearchText] = useDebounce(searchText, 1000);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [error, setError] = useState(null);
    const [messages, setMessages] = useState([]);
    const [messagesCurrentPage, setMessagesCurrentPage] = useState(1);
    const [messagesHasMore, setMessagesHasMore] = useState(true);
    const [isLoadingMoreMessages, setIsLoadingMoreMessages] = useState(false);
    const [messagesError, setMessagesError] = useState(null);
    const userId = localStorage.getItem("hoast_user_id");
    const popupRef = useRef(null);
    const desktopMessagesRef = useRef(null);
    const mobileMessagesRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const { joinRoom, leaveRoom, setCurrentRoom, setJoinedStatus, getCurrentRoom, getJoinedStatus } = useRoomManager();

    const fetchChatRooms = (page = 1, search = "", isLoadMore = false) => {
        const params = {
            page: page,
            limit: 10,
            ...(search && { search: search })
        };

        if (isLoadMore) {
            setIsLoadingMore(true);
        } else {
            setIsLoading(true);
            setError(null);
        }

        getChatsAPI(params)
            .then((response) => {

                if (response.data && response.data.status === 1) {
                    const apiData = response.data.data || [];
                    const { total_pages, current_page } = response.data;

                    const mappedChatRooms = apiData.map(chat => ({
                        id: chat.id,
                        profile_pic: chat.other_user_profile_image,
                        full_name: `${chat.other_user_firstname} ${chat.other_user_lastname}`,
                        text: chat.chat_messages && chat.chat_messages.length > 0
                            ? chat.chat_messages[0].message_type === "Text" ? chat.chat_messages[0].message_text : "media file"
                            : "No messages",
                        time: chat.latest_message_created_at,
                        unread_count: chat.unread_messages_count > 0
                            ? chat.unread_messages_count.toString()
                            : "",
                        isActive: chat.other_user_status === "online",
                        other_id: chat.other_id,
                        chat_messages: chat.chat_messages || []
                    }));

                    if (isLoadMore) {
                        setChatRooms(prev => [...prev, ...mappedChatRooms]);
                    } else {
                        setChatRooms(mappedChatRooms);
                    }

                    setHasMore(current_page < total_pages);
                    setCurrentPage(current_page);
                } else {
                    setError(response.data?.message || "Failed to fetch chat rooms");
                    setHasMore(false);
                }
            })
            .catch((error) => {
                setError(error.response?.data?.message || "Network error occurred");
                if (error?.response?.status === 401) {
                    localStorage.removeItem('hoast_token')
                    localStorage.removeItem('hoast_refresh_token')
                    navigate('/login');
                }
                if (!isLoadMore) {
                    setChatRooms([]);
                }
            })
            .finally(() => {
                setIsLoading(false);
                setIsLoadingMore(false);
            });
    };

    const fetchMoreChatRooms = () => {
        if (!isLoadingMore && hasMore) {
            fetchChatRooms(currentPage + 1, debouncedSearchText, true);
        }
    };

    const fetchChatMessages = (chatId, page, isLoadMore = false) => {
        if (!chatId) return;

        const params = {
            chat_id: chatId,
            page: page,
            limit: 20
        };

        if (isLoadMore) {
            setIsLoadingMoreMessages(true);
        } else {
            setMessagesError(null);
        }

        getChatMessagesAPI(params)
            .then((response) => {

                if (response.data && response.data.status === 1) {
                    const apiData = response.data.data || [];
                    const { total_pages, current_page } = response.data;

                    const mappedMessages = apiData.map(msg => {
                        const isFromCurrentUser = msg.message_by === parseInt(userId);
                        return {
                            id: msg.id,
                            message_text: msg.message_type === "Text" ? msg.message_text : msg.media_url,
                            message_type: msg.message_type,
                            created_at: msg.created_at,
                            isFromCurrentUser: isFromCurrentUser,
                            sender_name: `${msg.messageBy.firstname} ${msg.messageBy.lastname}`,
                            sender_profile: msg.messageBy.profile_image || placeholder,
                            message_status: msg.message_status,
                            thumbnail: msg.thumbnail,
                            media_text: msg.media_text,
                            file_name: msg.file_name
                        };
                    });

                    if (isLoadMore) {
                        setMessages(prev => [...prev, ...mappedMessages]);
                    } else {
                        setMessages(mappedMessages);
                    }

                    setMessagesHasMore(current_page < total_pages);
                    setMessagesCurrentPage(current_page);
                } else {
                    setMessagesError(response.data?.message || "Failed to fetch messages");
                    setMessagesHasMore(false);
                }
            })
            .catch((error) => {
                setMessagesError(error.response?.data?.message || "Network error occurred");
                setMessagesHasMore(false);
                if (!isLoadMore) {
                    setMessages([]);
                }
                if (error?.response?.status === 401) {
                    localStorage.removeItem('hoast_token')
                    localStorage.removeItem('hoast_refresh_token')
                    navigate('/login');
                }
            })
            .finally(() => {
                setIsLoadingMoreMessages(false);
            });
    };

    const fetchMoreMessages = () => {
        if (!isLoadingMoreMessages && messagesHasMore && selectedMessage?.id) {
            fetchChatMessages(selectedMessage.id, messagesCurrentPage + 1, true);
        }
    };

    const handleSearch = (searchValue) => {
        setSearchText(searchValue);
    };

    useEffect(() => {
        if (debouncedSearchText !== undefined) {
            setCurrentPage(1);
            setHasMore(true);
            fetchChatRooms(1, debouncedSearchText, false);
        }
    }, [debouncedSearchText]);

    useEffect(() => {
        if (selectedMessage?.id) {
            setMessagesCurrentPage(1);
            setMessagesHasMore(true);
            fetchChatMessages(selectedMessage.id, 1, false);
        }
    }, [selectedMessage]);

    useEffect(() => {
        const handleScroll = () => {
            const messagesContainer = window.innerWidth >= 1024 ? desktopMessagesRef.current : mobileMessagesRef.current;
            if (messagesContainer) {
                const { scrollTop, scrollHeight, clientHeight } = messagesContainer;
                const isScrolledUp = scrollTop < scrollHeight - clientHeight - 100;
                setShowScrollButton(isScrolledUp);
            }
        };

        const messagesContainer = window.innerWidth >= 1024 ? desktopMessagesRef.current : mobileMessagesRef.current;
        if (messagesContainer) {
            messagesContainer.addEventListener('scroll', handleScroll);
            return () => messagesContainer.removeEventListener('scroll', handleScroll);
        }
    }, [selectedMessage]);

    const handleJoinRoom = (roomId) => {
        if (roomId && roomId !== getCurrentRoom()) {
            joinRoom(roomId);
            setJoined(true);
        }
    };

    useEffect(() => {
        if (selectedMessage?.id) {
            handleJoinRoom(selectedMessage.id);
        }
    }, [selectedMessage?.id]);

    useEffect(() => {
        if (location.state?.id && chatRooms.length > 0) {
            const targetChatRoom = chatRooms.find(room => room.id === location.state.id);
            if (targetChatRoom) {
                setSelectedMessage(targetChatRoom);
                navigate('/messages', { replace: true });
            }
        }
    }, [location.state?.id, chatRooms, navigate]);

    useEffect(() => {
        const handleNewMessage = (data) => {
            if (data?.chat_id == selectedMessage?.id) {
                const formattedMessage = {
                    id: data.id || Date.now(),
                    message_text: data.message_type === "Text" ? data.message_text : data.media_url,
                    message_type: data.message_type || "Text",
                    created_at: data.created_at || new Date().toISOString(),
                    isFromCurrentUser: data.message_by === parseInt(userId),
                    sender_name: data.sender_name || "Unknown",
                    sender_profile: data.sender_profile || placeholder,
                    message_status: data.message_status || "sent",
                    thumbnail: data.thumbnail,
                    media_text: data.media_text,
                    file_name: data.file_name
                };

                setMessages((prevMessageList) => [formattedMessage, ...prevMessageList]);
                setTimeout(() => {
                    scrollToBottom();
                }, 100);
            }
        };

        Socket.on("new_message", handleNewMessage);
        return () => {
            Socket.off("new_message", handleNewMessage);
        };
    }, [selectedMessage?.id, userId]);

    const handleSendMessage = async () => {
        if (!selectedMessage?.id) {
            toast.error("Please select a conversation first");
            return;
        }

        if (!message.trim() && previews.length === 0) {
            toast.error("Please enter a message or select a file");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("chat_id", selectedMessage.id);

            const messageTypes = [];

            if (previews.length > 0) {
                const preview = previews[0];
                formData.append("media", preview.file);

                if (preview.type === "video") {
                    messageTypes.push("Video");
                } else if (preview.type === "image") {
                    messageTypes.push("Image");
                }
            }

            if (message.trim()) {
                formData.append("message_text", message.trim());
                messageTypes.push("Text");
            }

            formData.append("message_type", JSON.stringify(messageTypes));

            const response = await sendMessageAPI(formData);

            if (response?.data?.status === 1) {

                setMessage("");
                setPreviews([]);

                setTimeout(() => {
                    scrollToBottom();
                }, 100);

            } else {
                throw new Error(response?.data?.message || "Failed to send message");
            }
        } catch (error) {
            console.error("Error sending message:", error);
            toast.error(error?.response?.data?.message || error?.message || "Failed to send message");
        }
    };

    const scrollToBottom = () => {
        const messagesContainer = window.innerWidth >= 1024 ? desktopMessagesRef.current : mobileMessagesRef.current;
        if (messagesContainer) {
            messagesContainer.scrollTo({
                top: messagesContainer.scrollHeight,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        if (selectedMessage) {
            setTimeout(() => {
                scrollToBottom();
            }, 100);
        }
    }, [selectedMessage]);

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleSendMessage();
        }
    };

    const handleMessageClick = (item) => {
        if (selectedMessage?.id !== item.id) {
            setMessages([]);
        }
        setSelectedMessage(item);
        setChatRooms((prevUserList) =>
            prevUserList.map((user) =>
                user?.id === item.id
                    ? { ...user, unread_count: "" }
                    : user
            )
        );
    };

    const handleBackToMessages = () => {
        if (joined && getCurrentRoom()) {
            handleCloseRoom();
        }
        setSelectedMessage(null);
        setMessages([]);
        setChatRooms((prevUserList) =>
            prevUserList.map((user) =>
                user?.id === selectedMessage?.id
                    ? { ...user, unread_count: "" }
                    : user
            )
        );
    };

    const handleFiles = async (files, type) => {
        if (!files) return;

        const fileArray = Array.from(files);
        const newPreviews = [];
        for (let i = 0; i < fileArray.length; i++) {
            const file = fileArray[i];
            const url = URL.createObjectURL(file);

            newPreviews.push({ type, url, file });

            if (type === "video") {
                await generateVideoThumbnail(file, previews.length + i);
            }
        }
        setPreviews((prev) => [...prev, ...newPreviews]);
        setOpen(false);
    };

    const generateVideoThumbnail = (file, fileIndex) => {
        return new Promise((resolve) => {
            const video = document.createElement("video");
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            video.src = URL.createObjectURL(file);
            video.currentTime = 1;
            video.onloadeddata = () => {
                canvas.width = video.videoWidth / 4;
                canvas.height = video.videoHeight / 4;
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                canvas.toBlob((blob) => {
                    const thumbnailFile = new File([blob], `${file.name}_thumbnail.jpg`, {
                        type: "image/jpeg",
                    });

                    resolve(thumbnailFile);
                }, "image/jpeg");
            };

            video.onerror = () => {
                resolve(null);
            };
        });
    };

    const handleRemove = (indexToRemove) => {
        setPreviews((prev) => {
            const updated = [...prev];
            const removed = updated.splice(indexToRemove, 1)[0];
            if (removed?.url) {
                URL.revokeObjectURL(removed.url);
            }

            return updated;
        });
    };

    const isTypeAlreadySelected = (type) => {
        return previews.length > 0 && previews.some((item) => item.type !== type);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);

    useEffect(() => {
        return () => {
            if (joined && getCurrentRoom()) {
                handleCloseRoom();
            }
        };
    }, [selectedMessage?.id]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            if (joined && getCurrentRoom()) {
                handleCloseRoom();
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [joined, selectedMessage?.id]);

    useEffect(() => {
        Socket.on("unread_chat_count", (data) => handleCountUpdate(data));

        return () => {
            Socket.off("unread_chat_count", (data) => handleCountUpdate(data));
        };
    }, [Socket]);

    const handleCountUpdate = (data) => {
        console.log(data, "data>>>>>");
        setChatRooms((prevUserList) =>
            prevUserList.map((user) =>
                user.id === data.id
                    ? {
                        ...user,
                        unread_count: data.unread_messages_count,
                        text: data.chat_messages[0].message_type === "Text" ? data.chat_messages[0].message_text : "media file" || user.text,
                        time: data.latest_message_created_at || user.time
                    }
                    : user
            )
        );
    };

    const handleCloseRoom = () => {
        leaveRoom();
        setJoined(false);
    }

    if (isLoading) {
        return <MessagesSkeleton />;
    }

    return (
        <div className="bg-white rounded-lg p-1 shadow-sm h-[calc(100vh-110px)] flex flex-col">
            <div className="h-full flex">
                <div className={`${selectedMessage ? 'hidden lg:flex' : 'flex'} w-full lg:w-[27%] border-r md:border-gray-200 border-transparent flex-col`}>
                    <div className="p-3 sm:p-4">
                        <div className="flex justify-between items-center">
                            <h1 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-900">
                                Messages
                            </h1>
                        </div>

                        <div className="mt-3 sm:mt-4">
                            <div className="relative">
                                <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                <input
                                    type="search"
                                    placeholder="Search messages..."
                                    className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#F48B94] focus:border-transparent text-sm sm:text-base"
                                    name="search_text"
                                    autoComplete="off"
                                    value={searchText}
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div id="chat-list-container" className="flex-1 overflow-y-auto">
                        {chatRooms.length === 0 && !isLoading && !error && (
                            <div className="p-4 text-center h-full flex flex-col items-center justify-center">
                                <MessageSquareText className="w-12 h-12 text-gray-400 mx-auto mb-2" />
                                <p className="text-gray-500 text-sm">No chat rooms found</p>
                            </div>
                        )}

                        <InfiniteScroll
                            dataLength={chatRooms.length}
                            next={fetchMoreChatRooms}
                            hasMore={hasMore}
                            loader={
                                <div className="p-4 text-center">
                                    <div className="inline-flex items-center justify-center gap-2">
                                        <div className="animate-spin rounded-full h-5 w-5 border-2 border-[#F48B94] border-t-transparent"></div>
                                        <p className="text-gray-600 text-sm font-medium">Loading more chats...</p>
                                    </div>
                                </div>
                            }
                            scrollableTarget="chat-list-container"
                            style={{ overflow: 'visible' }}
                        >
                            {chatRooms.map((item, index) => {
                                const time = moment.utc(item.time).local().format("h:mm A");
                                return (
                                    <div
                                        key={index}
                                        className={`flex justify-between items-center p-3 sm:p-4 cursor-pointer transition-colors duration-200 hover:bg-gray-50 ${selectedMessage && selectedMessage.id === item.id
                                            ? 'bg-gray-100'
                                            : ''
                                            }`}
                                        onClick={() => handleMessageClick(item)}
                                    >
                                        <div className="flex items-center gap-3 flex-1 min-w-0">
                                            <div className='relative flex-shrink-0'>
                                                <img
                                                    src={item.profile_pic ? validateUrl(item.profile_pic) : profileImage}
                                                    className="w-10 h-10 sm:w-11 sm:h-11 rounded-full object-cover"
                                                    alt={item.full_name}
                                                />
                                                {item.isActive && (
                                                    <div className="absolute bottom-0 right-0 border-2 rounded-full border-white">
                                                        <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 bg-green-500 rounded-full"></div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <p className="font-medium text-gray-900 truncate text-sm sm:text-base">
                                                    {item.full_name}
                                                </p>
                                                <div className="flex items-center gap-2">
                                                    <p className="text-xs sm:text-sm text-gray-600 truncate">
                                                        {item.text}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-end ml-2 flex-shrink-0">
                                            <p className="text-xs text-gray-500">
                                                {time}
                                            </p>
                                            {item.unread_count && item.unread_count > 0 && (
                                                <div className="mt-1">
                                                    <span className="inline-flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-[#F48B94] rounded-full">
                                                        {item.unread_count > 99 ? "99+" : item.unread_count}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )
                            })}
                        </InfiniteScroll>
                    </div>
                </div>

                <div className={`${selectedMessage ? 'flex' : 'hidden lg:flex'} flex-1 flex flex-col`}>
                    {selectedMessage ? (
                        <>
                            <div className="p-3 sm:p-4 border-b border-gray-200 bg-white">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2 sm:gap-3">
                                        <button
                                            onClick={handleBackToMessages}
                                            className="lg:hidden p-1.5 sm:p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
                                        >
                                            <ArrowLeft className="w-5 h-5 text-gray-600" />
                                        </button>

                                        <div className='relative flex-shrink-0'>
                                            <img
                                                src={selectedMessage.profile_pic ? validateUrl(selectedMessage.profile_pic) : profileImage}
                                                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover"
                                                alt={selectedMessage.full_name}
                                            />
                                            {selectedMessage.isActive && (
                                                <div className="absolute bottom-0 right-0 border-2 rounded-full border-white">
                                                    <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 bg-green-500 rounded-full"></div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="min-w-0">
                                            <p className="font-semibold text-gray-900 text-sm sm:text-base truncate">
                                                {selectedMessage.full_name}
                                            </p>
                                            {selectedMessage.isActive && (
                                                <p className="text-xs sm:text-sm text-green-600 font-medium">Active Now</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {isLoadingMoreMessages && (
                                <div className=" bg-white p-3">
                                    <div className="flex items-center justify-center gap-2">
                                        <div className="animate-spin rounded-full h-5 w-5 border-2 border-[#F48B94] border-t-transparent"></div>
                                        <p className="text-gray-600 text-sm font-medium">Loading more messages...</p>
                                    </div>
                                </div>
                            )}

                            <div
                                id="messages-container"
                                ref={desktopMessagesRef}
                                className="flex-1 overflow-y-auto relative overflow-x-hidden scrollbar-custom p-3 sm:p-4 space-y-3 sm:space-y-4"
                                style={{
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                }}
                            >
                                {messages.length === 0 && !messagesError && (
                                    <div className="p-4 text-center h-[63vh] flex flex-col items-center justify-center">
                                        <MessageSquareText className="w-12 h-12 text-gray-400 mx-auto mb-2" />
                                        <p className="text-gray-500 text-sm">No messages found</p>
                                    </div>
                                )}

                                <InfiniteScroll
                                    dataLength={messages.length}
                                    next={fetchMoreMessages}
                                    hasMore={messagesHasMore}
                                    loader={
                                        <div className="p-4 text-center">
                                            <div className="inline-flex items-center justify-center gap-2">
                                                <div className="animate-spin rounded-full h-5 w-5 border-2 border-[#F48B94] border-t-transparent"></div>
                                                <p className="text-gray-600 text-sm font-medium">Loading messages...</p>
                                            </div>
                                        </div>
                                    }
                                    scrollableTarget="messages-container"
                                    inverse={true}
                                >
                                    {[...messages].reverse().map((msg) => {
                                        const time = moment.utc(msg.created_at).local().format("h:mm A");

                                        return (
                                            <div key={msg.id} className="mb-2">
                                                {msg.isFromCurrentUser ? (
                                                    <div className="flex justify-end mb-1">
                                                        <div className="max-w-[85%] sm:max-w-[80%] lg:max-w-xs xl:max-w-xl bg-[#F48B94] text-white break-words rounded-xl px-3 sm:px-4 py-2">
                                                            {msg.message_type === "Text" && (
                                                                <p className="text-sm">{msg.message_text}</p>
                                                            )}

                                                            {msg.message_type === "Image" && (
                                                                <Zoom>
                                                                    <img
                                                                        src={validateUrl(msg.message_text)}
                                                                        alt="Message Image"
                                                                        className="w-[200px] h-[200px] object-cover rounded-md"
                                                                    />
                                                                </Zoom>
                                                            )}

                                                            {msg.message_type === "Video" && (
                                                                <video
                                                                    controls
                                                                    className="w-[200px] h-[200px] object-cover rounded-md"
                                                                >
                                                                    <source src={validateUrl(msg.message_text)} type="video/mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="flex justify-start mb-1">
                                                        <div className="max-w-[85%] sm:max-w-[80%] lg:max-w-xs xl:max-w-xl bg-gray-100 text-gray-900 break-words rounded-xl px-3 sm:px-4 py-2">
                                                            {msg.message_type === "Text" && (
                                                                <p className="text-sm">{msg.message_text}</p>
                                                            )}

                                                            {msg.message_type === "Image" && (
                                                                <Zoom>
                                                                    <img
                                                                        src={validateUrl(msg.message_text)}
                                                                        alt="Message Image"
                                                                        className="w-[200px] h-[200px] object-cover rounded-md"
                                                                    />
                                                                </Zoom>
                                                            )}

                                                            {msg.message_type === "Video" && (
                                                                <video
                                                                    controls
                                                                    className="w-[200px] h-[200px] object-cover rounded-md"
                                                                >
                                                                    <source src={validateUrl(msg.message_text)} type="video/mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                <div className={`text-[10px] text-gray-500 ${msg.isFromCurrentUser ? 'text-right ml-1' : 'text-left mr-1'}`}>
                                                    {time}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </InfiniteScroll>

                                {showScrollButton && messages.length > 10 && (
                                    <div className='flex justify-center items-center sticky bottom-4 z-50'>
                                        <button
                                            onClick={scrollToBottom}
                                            className="w-10 h-10 bg-[#212121] shadow-2xl text-white rounded-full hover:bg-[#e67a83] transition-all duration-300 flex items-center justify-center group"
                                            style={{
                                                animation: 'fadeInUp 0.3s ease-out'
                                            }}
                                        >
                                            <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5" />
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className="p-3 border-t border-gray-200">
                                {previews.length > 0 && (
                                    <div className="mb-3 flex flex-wrap gap-2 border rounded-lg p-2">
                                        {previews.map((item, index) => (
                                            <div
                                                key={index}
                                                className="relative group border rounded shadow p-1 overflow-hidden"
                                            >
                                                <button
                                                    onClick={() => handleRemove(index)}
                                                    className="absolute top-1 right-1 z-10 text-white bg-[#F48B94] bg-opacity-80 rounded-full p-0.5 hidden group-hover:block transition duration-300 ease-in-out hover:bg-opacity-90"
                                                >
                                                    <RxCrossCircled className="text-sm sm:text-base" />
                                                </button>

                                                {item.type === "image" && (
                                                    <img
                                                        src={item.url}
                                                        alt="Preview"
                                                        className="w-14 h-14 sm:w-20 sm:h-20 lg:w-24 lg:h-24 object-cover rounded"
                                                    />
                                                )}

                                                {item.type === "video" && (
                                                    <div className="relative w-14 h-14 sm:w-20 sm:h-20 lg:w-24 lg:h-24">
                                                        <video
                                                            src={item.url}
                                                            className="w-full h-full object-cover rounded"
                                                            poster={previews.find((thumb) => thumb.type === "image")?.url || ""}
                                                        />
                                                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
                                                            <Video className="text-white text-sm sm:text-base lg:text-lg" />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <div className="flex items-center gap-2 sm:gap-3">
                                    <div className="relative">
                                        <button
                                            onClick={() => setOpen(!open)}
                                            className="w-8 h-8 sm:w-10 sm:h-10 bg-[#F48B94] text-white rounded-full flex items-center justify-center transition-colors duration-200 flex-shrink-0"
                                        >
                                            <Plus className="w-4 h-4" />
                                        </button>

                                        {open && (
                                            <div
                                                ref={popupRef}
                                                className="absolute z-50 bottom-full mb-2 w-36 sm:w-44 bg-white border rounded-lg shadow-md text-sm"
                                            >
                                                <label
                                                    htmlFor="imageUpload"
                                                    className={`flex items-center gap-2 px-3 sm:px-4 py-2 hover:bg-gray-100 cursor-pointer ${isTypeAlreadySelected("image") ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
                                                        }`}
                                                >
                                                    <MdImage className="text-blue-500 text-lg" />
                                                    <span className="text-xs sm:text-sm">Image</span>
                                                </label>
                                                <label
                                                    htmlFor="videoUpload"
                                                    className={`flex items-center gap-2 px-3 sm:px-4 py-2 hover:bg-gray-100 cursor-pointer ${isTypeAlreadySelected("video") ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
                                                        }`}
                                                >
                                                    <MdVideoLibrary className="text-[#F48B94] text-lg" />
                                                    <span className="text-xs sm:text-sm">Video</span>
                                                </label>

                                                <input
                                                    id="imageUpload"
                                                    type="file"
                                                    accept=".png, .jpg, .jpeg, .svg"
                                                    multiple
                                                    className="hidden"
                                                    disabled={isTypeAlreadySelected("image")}
                                                    onChange={(e) => handleFiles(e.target.files, "image")}
                                                />
                                                <input
                                                    id="videoUpload"
                                                    type="file"
                                                    accept="video/*"
                                                    multiple
                                                    className="hidden"
                                                    disabled={isTypeAlreadySelected("video")}
                                                    onChange={(e) => handleFiles(e.target.files, "video")}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="flex-1 relative">
                                        <input
                                            type="text"
                                            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-100 border-0 rounded-full focus:outline-none focus:ring-2 focus:ring-[#F48B94] text-gray-900 placeholder-gray-500 text-sm sm:text-base"
                                            placeholder="Type a message..."
                                            value={message}
                                            onFocus={() => setOpen(false)}
                                            disabled={previews.length > 0}
                                            onChange={(e) => setMessage(e.target.value)}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </div>

                                    <button
                                        onClick={handleSendMessage}
                                        className="w-8 h-8 sm:w-10 sm:h-10 bg-[#F48B94] text-white rounded-full flex items-center justify-center transition-colors duration-200 flex-shrink-0"
                                    >
                                        <Send className="w-4 h-4" />
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="flex-1 flex items-center justify-center">
                            <div className="text-center px-4">
                                <MessageSquareText className="w-12 h-12 sm:w-16 sm:h-16 text-gray-400 mx-auto mb-4" />
                                <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-2">No conversation selected</h3>
                                <p className="text-sm sm:text-base text-gray-500">Choose a conversation from the list to start messaging</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
